import React from "react";
import { pure } from "recompose";

import RoundLink from "components/round-link";
import DashboardBarChart from "./DashboardBarChart";
import MarketButton from "../../containers/market-button";
import DashboardLineChart from "./DashboardLineChart";
import IconTableHelp from "../../containers/assets/icon-table-help.svg";
import Teams from "../../api/Teams";

const HowTeamDid = pure(({ teamGradings, round_number }) => {
  const teamColor = Teams.currentTeamColorLevel3();

  return (
    <div className="dashboard-summary">
      <div style={{ paddingRight: 0 }}>
        <div className="dashboard-summary__chartHeader">
          <h5>Overall Score</h5>
          <img alt="Overall Score icon help" src={IconTableHelp} />
        </div>
        <DashboardBarChart
          teamGradings={teamGradings}
          round_number={round_number}
        />
      </div>
      <div>
        <div className="dashboard-summary__chartHeader">
          <h5>Score Trend</h5>
          <img alt="Score Trend icon help" src={IconTableHelp} />
          <div className="dashboard-summary__teamColor">
            <div
              style={{
                width: "12px",
                height: "2px",
                backgroundColor: teamColor
              }}
            />
            <div className="dashboard-summary__teamColor_title">Your team</div>
          </div>
        </div>
        <DashboardLineChart teamGradings={teamGradings} round_number={round_number} />
      </div>
      <div>
        <h5 className="dashboard-summary__title">
          Year {round_number} Results
        </h5>
        <p className="dashboard-summary__text">
          Want to gain a better understanding of your team's performance in
          relative to your competitors'? Review your Team Report below.
        </p>
        <RoundLink to="/team-reports" round={round_number}>
          <MarketButton type="solid" variant="error">
            See Full Team Reports
          </MarketButton>
        </RoundLink>
      </div>
    </div>
  );
});

export default HowTeamDid;



// WEBPACK FOOTER //
// ./src/components/dashboard/HowTeamDid.js